import { Component } from '@angular/core';

@Component({
    template: `placeholder for downloads`
})
export class DownloadComponent {}
